import type {RouteLocationNormalizedLoaded} from 'vue-router'
import {useNotification} from "@/composables/useNotification"

declare module 'vue-router' {
    interface RouteMeta {
        mustPossessAbility?: {
            action: string
            subject: string
        },
        feature?: string
    }
}

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedLoaded) => {
    const {$can, $i18n} = useNuxtApp()

    const requirement = to.meta.mustPossessAbility
    if (requirement && !$can(requirement.action, requirement.subject)) {
        useNotification().warning(String($i18n.t('canNotAccessRoute')))
        const localePath = useLocalePath()
        return navigateTo(localePath('/dashboard'))
    }

    if (to.meta?.feature) {
        const hasFeature = useFeature(to.meta.feature)
        if (!hasFeature) {
            useNotification().warning(useNuxtApp().$i18n.t('canNotAccessRoute'))
            return navigateTo(useLocalePath()('/dashboard'))
        }
    }
})